export const environment = {
  production: false,
  envDeployed: 'dev',
  apiUrl: 'https://api-mono-dev.munily.xyz',
  version: '1.0.0-dev',
  amplitude: {
    apiKey: '46c912ce0505f555a0cfc2682c2a2641'
  },
  firebaseConfig: {
    apiKey: "AIzaSyBkEM9yTL3w_GBx-JNb20ySK7IPvp_LHcA",
    authDomain: "munily-dev-f8b14.firebaseapp.com",
  }
};
